module.exports = __webpack_public_path__ + "img/tire-video-bg.64e03be0.png";